import { fromTable } from "../utils/tables";
import { origins } from "../tables";

export const getOrigin = ({ formatMessage }) => {
  const result = fromTable(origins);
  const benefit = fromTable(result.benefits);

  return {
    name: formatMessage(result.name),
    description: formatMessage(result.description),
    benefit: {
      name: formatMessage(benefit.name),
      description: formatMessage(benefit.description),
    },
  };
};
